import React from "react";
import AddIcon from "../UIComponents/AddIcon";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  getVendorList,
  deleteVendorDetails,
} from "../Actions/VendorManagementAPI";
import Autocomplete from "react-autocomplete";
import { getEquipmentNameList } from "../Actions/helpersAPI";
import { getZoneList } from "../Actions/VendorManagementAPI";
import { getPortAndCountry } from "../Actions/ServiceProviderAPI";
import VendorCard from "./VendorCard";
import { toast } from "react-toastify";
import axios from "axios";
import API from "../helpers/api";
import { confirmAlert } from "react-confirm-alert";
import $ from "jquery";

let currentuser = JSON.parse(localStorage.getItem("currentUser"));
let SearchItems = {
  VendorName: "",
  Equipment: "",
  Zone: "",
  country: "",
  port: "",
  PageNumber: 1,
  PageSize: 20,
}

class VendorManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchData: {
        VendorName: "",
        Equipment: "",
        Zone: "",
        country: "",
        port: "",
        PageNumber: 1,
        PageSize: 20,
      },
      openPort: false,
      openCountry: false,
      openEquipment: false,
    };
    this.SearchVendor = this.SearchVendor.bind(this);
    this.ClearInput = this.ClearInput.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    const { dispatch ,t} = this.props;
    dispatch({ type: "ShowSidePan", data: false });
    if (this.props.vendorSearch) {
      this.state.searchData = this.props.vendorSearch;
    }
    dispatch(getVendorList(this.state.searchData));
    dispatch(getPortAndCountry(this.state.searchData));
    dispatch({ type: "SubBannerTitle", data: "Vendor Management" });
    let searchitem = this.state.searchData;
    let _this = this;
    this.keyPressHandler = function (event) {
      var keycode = event.keyCode || event.which;
      // if (searchitem.Equipment || searchitem.Zone || searchitem.VendorName) 

      if (keycode === 13) {
        if (_this.verifySearchItems()) {
          _this.SearchVendor(1);
        }
        else {
          toast.success(t('Toast.Success'), {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      }
    }

    $(document).keypress(this.keyPressHandler);
  }


  componentWillUnmount() {

    $(document).off("keypress", this.keyPressHandler);
  }

  SearchVendor(pgno) {
    const { dispatch } = this.props;
    this.state.searchData.PageNumber = pgno;
    dispatch({ type: "vendorSearch", data: this.state.searchData });
    dispatch(getVendorList(this.state.searchData));
  }

  verifySearchItems = () => {
    let flag = true;
    const search = this.state.searchData;
    if (search.VendorName == "" && search.Equipment == "" && search.Zone == "") {
      flag = false;
    }
    return flag;
  }

  SearchVendor1(pgno) {
    const { dispatch, t } = this.props;
    if (this.verifySearchItems()) {

      this.state.searchData.PageNumber = pgno;
      dispatch({ type: "vendorSearch", data: this.state.searchData });
      dispatch(getVendorList(this.state.searchData));
    }
    else {
      toast.success(t('Toast.Success'), {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  handleInputChange(e, field) {
    this.state.searchData[field] = e.target.value;
    this.setState({});
  }

  eyeclick(item) {
    const { dispatch, history } = this.props;
    history.push(`/Home/VendorManagementDetails/${item.equipmentId}`);
  }

  deleteVendor(item) {
    const { t } = this.props;
    confirmAlert({
      message: `${t("confirmAlertMessage.DeleteMsg")}`,
      buttons: [
        {
          label: `${t("confirmAlertMessage.Yes")}`,
          onClick: () => {
            const { dispatch, VendorList } = this.props;
            let vendor = {
              equipmentId: item.equipmentId,
              modifiedBy: currentuser.email,
            };
            let url = `${API.deleteVendor}`;
            axios({
              method: "DELETE",
              url: url,
              data: vendor,
            })
              .then((response) => {
                let searchData = {
                  VendorName: "",
                  Equipment: "",
                  Zone: "",
                  country: "",
                  port: "",
                  PageNumber: this.state.searchData.PageNumber - 1,
                  PageSize: 20,
                };
                if (
                  VendorList.pagination.hasNext === false &&
                  VendorList.data.length === 1
                ) {
                  dispatch({ type: "vendorSearch", data: searchData });
                  dispatch(getVendorList(searchData));
                } else {
                  dispatch({ type: "vendorSearch", data: this.state.searchData });
                  dispatch(getVendorList(this.state.searchData));
                }
                dispatch({
                  type: "deleteVendorDetailSuccess",
                  data: response.data,
                });
                toast.success(`${t("CommonText.CommonDelete")}`, {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              })
              .catch((error) => {
                dispatch({
                  type: "deleteVendorDetailFailure",
                  error: "ERROR",
                });
              });
          },
        },
        {
          label: `${t("confirmAlertMessage.No")}`,
          onClick: () => { },
        },
      ],
    });
  }

  ClearInput() {
    this.state.searchData.VendorName = "";
    this.state.searchData.Equipment = "";
    this.state.searchData.Zone = "";
    this.state.searchData.country = "";
    this.state.searchData.port = "";
    this.setState({});
    this.props.dispatch({ type: "vendorSearch", data: "" });
    this.props.dispatch(getVendorList(this.state.searchData));
  }

  NewitemNav = () => {
    localStorage.setItem("EditVendorName", "");
    localStorage.setItem("EditEquipmentName", "");
    localStorage.setItem("EditZoneNameId", "");
    localStorage.setItem("EditEquipmentNameId", "");
    this.props.dispatch({ type: "NewVendorDetailsAdd", data: false });
    this.props.dispatch({ type: "NewEquipmentDetailsAdd", data: false });
    this.props.dispatch({ type: "NewZoneDetailsAdd", data: false });
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.history.push("/Home/VendorManagementNewItem");
  };
  handleSelectChange(value, field) {
    if (field === "country") {
      this.state.searchData[field] = value;
      this.setState({}, () => {
        console.log(this.state.searchData);
      });
      this.props.dispatch(getPortAndCountry(this.state.searchData));
    }
    this.state.searchData[field] = value;
    this.setState({}, () => {
      console.log(this.state.searchData);
    });
  }
  renderCountryTitle(state, val) {
    return state?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
  }
  renderPortTitle(state, val) {
    return state?.port?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
  }
  renderEquipmentTitle(state, val) {
    return (
      state?.toLowerCase().indexOf(val?.toLowerCase()) !== -1
    );
  }

  render() {
    const {
      showSidePane,
      VendorList,
      EquipmentNameList,
      zoneList,
      PortList,
      Loading,
      VendorCountryList,
      t
    } = this.props;
    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-12">
                  <div className="panel-box">
                    <div
                      className="card MM-card-header mb-0"
                      style={{ backgroundColor: "white" }}
                    >
                      <div
                        className="card-body flex"
                        style={{
                          padding: "0rem",
                          backgroundColor: "#1a3464",
                          color: "white",
                        }}
                      >
                        <h5
                          className="card-title ml-2 mt-2 f2"
                          style={{ color: "092a51" }}
                        >
                          {t("VendorManagementScreenContent.Title")}
                        </h5>
                        <div className="m-1 flex" onClick={this.NewitemNav}>
                          <span className="mt-1">{t("ShipManagementContent.Add")}</span>
                          <AddIcon />
                        </div>
                      </div>
                    </div>
                    <div className="search-filter-box">
                      <div className="row">
                        <div className="col-lg-4">
                          <label className="form-label">{t("VendorManagementScreenContent.VendorName")}</label>
                          <br></br>
                          <input
                            type="text"
                            className="form-control"
                            name="VendorName"
                            value={this.state.searchData.VendorName}
                            placeholder={t("VendorManagementScreenContent.VendorName")}
                            onChange={(e) => this.handleInputChange(e, "VendorName")}
                          ></input>
                        </div>
                        <div className="col-lg-4">
                          <div className="autocomplete-wrappers"
                            style={{
                              zIndex: this.state.openEquipment && !Loading
                                ? 99999
                                : null,
                            }}>
                            <label className="form-label">{t("ShipEquipmentStatusScreen.Equipment")}</label>
                            <br></br>
                            <div className="autocompleteiicon">
                              <Autocomplete
                                open={!Loading ? this.state.openEquipment : false}
                                onMenuVisibilityChange={(isOpen) => {
                                  this.state.openEquipment = isOpen;
                                  this.setState({});
                                }}
                                contentEditable={true}
                                value={this.state.searchData.Equipment}
                                inputProps={{ placeholder: `${t("ShipEquipmentStatusScreen.Equipment")}` }}
                                items={EquipmentNameList ?? []}
                                getItemValue={(item) => item}
                                shouldItemRender={this.renderEquipmentTitle.bind(
                                  this
                                )}
                                renderMenu={(item) => (
                                  <div className="dropdown">{item}</div>
                                )}
                                renderItem={(item, isHighlighted) => (
                                  <div
                                    className={`items ${isHighlighted ? "selected-items" : ""
                                      }`}
                                  >
                                    {item}
                                  </div>
                                )}
                                onChange={(e, field) =>
                                  this.handleInputChange(e, "Equipment")
                                }
                                onSelect={(value) =>
                                  this.handleSelectChange(value, "Equipment")
                                }

                              />
                              <i className="fas fa-chevron-down icon-small"></i>
                            </div>
                          </div>
                        </div>

                        <div className={"col-lg-4"}>
                          <label className="form-label">{t("ZoneScreen.Title")}</label>
                          <br></br>
                          <select
                            className="form-control"
                            name="Zone"
                            value={this.state.searchData.Zone}
                            onChange={(e) => this.handleInputChange(e, "Zone")}
                          >
                            <option value="">{t("VendorManagementScreenContent.SelectZone")}</option>
                            {zoneList &&
                              zoneList?.map((zonename) => (
                                <option value={zonename.value}>
                                  {zonename.value}
                                </option>
                              ))}
                          </select>
                        </div>
                        {/*   <div className="col-lg-4">
                          <div className="autocomplete-wrappers"
                           style={{
                            zIndex:this.state.openCountry && !Loading
                                ? 99999
                                : null,
                          }}>
                            <label className="form-label">Country</label>
                            <br></br>
                            <Autocomplete
                            open={!Loading ? this.state.openCountry : false}
                            onMenuVisibilityChange={(isOpen) => {
                              this.state.openCountry = isOpen;
                              this.setState({});
                            }}
                              contentEditable={true}
                              value={this.state.searchData.country}
                              inputProps={{ placeholder: "Country" }}
                              items={VendorCountryList ?? []}
                              getItemValue={(item) => item}
                              shouldItemRender={this.renderCountryTitle.bind(
                                this
                              )}
                              renderMenu={(item) => (
                                <div className="dropdown">{item}</div>
                              )}
                              renderItem={(item, isHighlighted) => (
                                <div
                                  className={`items ${
                                    isHighlighted ? "selected-items" : ""
                                  }`}
                                >
                                  {item}
                                </div>
                              )}
                              onChange={(e, field) =>
                                this.handleInputChange(e, "country")
                              }
                              onSelect={(value) =>
                                this.handleSelectChange(value, "country")
                              }
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="autocomplete-wrappers"
                           style={{
                            zIndex:this.state.openPort && !Loading
                                ? 99999
                                : null,
                          }}>
                            <label className="form-label">Port</label>
                            <br></br>
                            <Autocomplete
                            open={!Loading ? this.state.openPort : false}
                            onMenuVisibilityChange={(isOpen) => {
                              this.state.openPort = isOpen;
                              this.setState({});
                            }}
                              contentEditable={true}
                              value={this.state.searchData.port}
                              inputProps={{ placeholder: "Port" }}
                              items={PortList ?? []}
                              getItemValue={(item) => item.port}
                              shouldItemRender={this.renderPortTitle.bind(this)}
                              renderMenu={(item) => (
                                <div className="dropdown">{item}</div>
                              )}
                              renderItem={(item, isHighlighted) => (
                                <div
                                  className={`items ${
                                    isHighlighted ? "selected-items" : ""
                                  }`}
                                >
                                  {item.port}
                                </div>
                              )}
                              onChange={(e, field) =>
                                this.handleInputChange(e, "port")
                              }
                              onSelect={(value) =>
                                this.handleSelectChange(value, "port")
                              }
                            />
                          </div>
                        </div> */}
                        <div className={"col-lg-12"}>
                          <div
                            className="form-group search-btn-col mt-4"
                            style={{ textAlign: "end" }}
                          >
                            <button
                              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                              type="submit"
                              onClick={() => this.SearchVendor1(1)}
                            >
                              {" "}
                              {t("content.Search")}{" "}
                            </button>
                            <button
                              className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                              type="button"
                              onClick={() => this.ClearInput()}
                            >
                              {" "}
                              {t("content.Clear")}{" "}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {VendorList ? (
                <VendorCard
                  currentPage={(VendorList.pagination.currentPage - 1) * VendorList.pagination.pageSize}
                  arraylist={VendorList.data}
                  totalRecords={
                    VendorList.pagination?.totalcount
                      ? VendorList.pagination?.totalcount
                      : 0
                  }

                  pageSize={VendorList.pagination?.pageSize}
                  setUpdatedState={(value) => this.SearchVendor(value)}
                  eyeclick={(item) => this.eyeclick(item)}
                  deleteVendor={(item) => this.deleteVendor(item)}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan,
    VendorList: state.VendorManagementReducer.VendorList,
    EquipmentNameList: state.MasterScreenReducer.EquipmentNameList || [],
    zoneList: state.VendorManagementReducer.zoneList,
    vendorSearch: state.VendorManagementReducer.vendorSearch,
    Loading: state.PageLoaderReducer.loading,
    PortList: state.MasterScreenReducer.PortLists || [],
    VendorCountryList: state.VendorManagementReducer.VendorCountryList || [],
  };
}
export default withTranslation()(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(VendorManagement)));
